<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Service - {{this.subTitle}}</h2>
				
			</b-col>
			<!--Gear Icon-->
			<b-col lg="6">
				<b-dropdown :disabled="edit" class="pull-right" right  variant="info" no-caret>
					<template slot="button-content">
							<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item v-if="tabIndex==0" @click="editservice">Edit</b-dropdown-item>
					<b-dropdown-item v-if="tabIndex==0" @click="deleteservice">Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>
	    	<b-card v-if="loadingData">
              	<b-col cols="12" sm="12" md="12" lg="12">
                 	<p class="text-center">
                  		<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
                 	</p>
              	</b-col>
            </b-card>
				<div v-else>
					<b-card  v-if="found">
				      		<b-row>
				      			<b-col md="8">
										<b-form-group label="Service Name" label-for="servicename" :label-cols="4" horizontal>
											<b-form-input class="plaintext-input" v-show="!edit" plaintext id="servicename" v-model="model.name" type="text" :readonly="!edit"></b-form-input>
											<b-form-input class="plaintext-input" v-show="edit" id="servicename" v-model="model.name" type="text"></b-form-input>
										</b-form-group>

										<b-form-group label="Energy Company" label-for="servicename" :label-cols="4" horizontal>
											<b-form-input class="plaintext-input"  plaintext id="servicename" v-model="model.energy_company" type="text" :readonly="!edit"></b-form-input>
										</b-form-group>


										<div v-if="edit" slot="footer">
											<b-button @click="updateservice" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
											<b-button  @click="editservice" size="sm" ><i class="fa fa-ban"></i> Cancel</b-button>
					        			</div>
								</b-col>
							</b-row>
					</b-card>

					<b-row v-else>
						<b-col cols="12" sm="12" md="12" lg="12">
						<br>
							<p class="text-center text-danger">
								<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
							</p>
						</b-col>
					</b-row>
        		</div>

	</div>
</template>

<script>
	// ********** imports ************ //
	import Vue from 'vue'
	import folders_service from './folders_service'

	export default {
		name: 'folder',
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		created: function() {
			this.getFolderData()
		},
		data() {
			return {
				originalData: null,
				edit: false,
				loadingData: true,
				tabIndex: 0,
				found: false,
				notFoundMessage: 'Not found',
				subTitle: "",
				model:{
						name : '',
						energy_company:''
						// roles_selected: [],
						// roles_newselected: []
				},
				roles :	[],
				roles1 :[],
				ServiceID:null,
				indeterminate: false,
				rolesAllSelected: false
			}
		},
		methods: {
			rolesToggleAll(checked) {
				this.model.roles_newselected = checked ? this.roles1.map(item => {
					return item.value
				}) : []
			},
			rolesChange() {
				if (this.model.roles_newselected.length === 0) {
					this.indeterminate = false
					this.rolesAllSelected = false
				} else if (this.model.roles_newselected.length === this.roles1.length) {
					this.indeterminate = false
					this.rolesAllSelected = true
				} else {
					this.indeterminate = true
					this.rolesAllSelected = false
				}
			},
			editservice() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.edit = true
				}
			},
			restoreOriginalData() {
				let model = this.originalData
				console.log(this.model)
				console.log(model)
				this.model = JSON.parse(JSON.stringify(model))
				// this.roles1=this.update_data.roles.map(item => {
				// 	return { text: item.name, value: item.id } })
				// this.roles=this.update_data.roles_selected.map(item => {
				// 	return { text: item.name, value: item.id, service_id : item.service_id } })
				// this.model.roles_selected = this.roles.map(item => {
				// 				return item.value })
				// this.model.roles_newselected = this.model.roles_selected
			},
			getFolderData() {
				folders_service.getBy(this.id)
					.then(data => {
						if (data.status == 'success') {
							console.log(data)
							this.originalData = data.folder
							this.update_data  = data.update_data
							this.restoreOriginalData()
							this.subTitle = data.folder.name
							this.found = true
							this.loadingData = false
						} else {
							this.$swal(data[0], data[1], data[0])
							this.loadingData = false
							}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
				if (this.model.name === undefined || this.model.name.trim().length == 0) {
					this.$swal('Alert!', 'Service Name can not be empty', 'warning')
					return false
				}
				return true
			},
			updateservice() {
				if (!this.okToUpdate()) {
					return
				}
					folders_service.update(this.id, this.model)
						.then((data) => {
							this.$swal(data[0], data[1], data[0])
							if (data[0] == 'success') {
								this.getFolderData()

							}
						})
						.catch(error => {
							this.$swal('Error', 'Server not response. ' + error, 'error')
						})
						this.edit=false
			},
			deleteservice() {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Folder: " + this.subTitle + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						this.deleteAllR()
						folders_service.delete(this.id)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.$router.push('/folders')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			deleteAllR() {
				var nelem = this.roles.length
				console.log(this.roles)
				if (nelem>0) {
					for (var i = 0; i < nelem; i++) {
						folders_service.deleteR(this.roles[i].service_id)
							.then(data => {
								if (data[0] != 'success') {
									this.$swal(data[0], data[1], data[0])
								}})
							.catch(error => {this.$swal('Error', 'Server not response. ' + error, 'error')})
					}
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/folders/folder.vue